import { render, staticRenderFns } from "./DepositFooter.vue?vue&type=template&id=6ea66ad0"
import script from "./DepositFooter.vue?vue&type=script&lang=js"
export * from "./DepositFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports